"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronEvent = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const CronTask_1 = require("../domain/CronTask");
const transformToDate_1 = require("../transformers/transformToDate");
let CronEvent = class CronEvent {
    _id = (0, uuid_1.v4)();
    startedAt = new Date();
    finishedAt;
    failedAt;
    key;
    payload;
};
exports.CronEvent = CronEvent;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CronEvent.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    __metadata("design:type", Date)
], CronEvent.prototype, "startedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CronEvent.prototype, "finishedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CronEvent.prototype, "failedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CronEvent.prototype, "key", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], CronEvent.prototype, "payload", void 0);
exports.CronEvent = CronEvent = __decorate([
    (0, typeorm_1.Entity)("cronEvents")
], CronEvent);
//# sourceMappingURL=CronEvent.js.map